import {FLEETACT} from '../actiontype'
import request from '@/utils/request'
import {fleetActivityApi} from '@/api'
import inlineSign from '@/utils/inlinesign'
export const fleetactAction = (v) => {
  const action = (data) => (
    {
      type: FLEETACT,
      data
    }
  )
  return async (dispatch) => {
    let data = await request.get(fleetActivityApi,{},{
        ...inlineSign
    })
    if(data.data.data){
        dispatch(action(data.data.data))
    }
  }
}